import Vue from 'vue'
import Router from 'vue-router'
import spView from 'views/spView'
import login from 'views/login'
// import accountList from 'views/accountList'
// import accountDatum from 'views/accountDatum'
import dailyReport from 'views/dailyReport'
import userList from 'views/userList'
import authList from 'views/authList'
import userDatum from 'views/userDatum'
import authOption from 'views/authOption'
import changepswd from 'views/changepswd'
// import loginSalePlatform from 'views/loginSalePlatform'
// import changeParentSales from 'views/changeParentSales'
// import changeParentSalesNew from 'views/changeParentSalesNew'
// import clientParentInfo from 'views/clientParentInfo'
// import relation from 'views/relation' //关系树状图

// 佣金主页面
import commisionIframe from 'views/CommissionSetting2/commissionSpbo2'
// import commissionView from 'views/CommissionSetting/commissionView'
// import ibPrimary from 'views/CommissionSetting/ibPrimary' // 代理首选项
// import salePrimary from 'views/CommissionSetting/salePrimary' //销售首选项

// 代理的一些页面
// import ibSetting from 'views/CommissionSetting/IB/IBSetting/ibSettingView'
// import IBCommissionSetting from 'views/CommissionSetting/IB/IBSetting/ibCommissionSetting'
// import realTimeResult from 'views/CommissionSetting/IB/IBResult/realTimeResult'
// import realTimeDetailResult from 'views/CommissionSetting/IB/IBResult/realTimeDetailResult'
// import monthlyIBResult from 'views/CommissionSetting/IB/IBResult/monthlyIBResult'
// import monthlyIBCommisionResult from 'views/CommissionSetting/IB/IBResult/monthlyIBCommisionResult'
// import monthCommDetailResult from 'views/CommissionSetting/IB/IBResult/monthCommDetailResult'
// import CPACommissionResult from 'views/CommissionSetting/IB/IBResult/CPACommissionResult'
// import CPAMonthlyCommResult from 'views/CommissionSetting/IB/IBResult/CPAMonthlyCommResult'
// import CPAMonthlyCommDetailResult from 'views/CommissionSetting/IB/IBResult/CPAMonthlyCommDetailResult'
// import ibReport from 'views/CommissionSetting/IB/IBReport/ibReport'
// import auditTrailReport from 'views/CommissionSetting/IB/IBReport/auditTrailReport'
// import auditTrailDetailReport from 'views/CommissionSetting/IB/IBReport/auditTrailDetailReport'
// import spreadCommissionMappingReport from 'views/CommissionSetting/IB/IBReport/spreadCommissionMappingReport'
// import allCommissionReport from 'views/CommissionSetting/IB/IBReport/allCommissionReport'
// import AlertIgnore from 'views/CommissionSetting/IB/AlertIgnore/AlertIgnore'
// import AlertIgnore_new from 'views/CommissionSetting/IB/AlertIgnore/AlertIgnore2'
// import ibTemplateMaintenanceV1 from 'views/CommissionSetting/IB/IBTemplateSetting/ibTemplateSetting'


// 销售的一些页面
// import saleSetting from 'views/CommissionSetting/Sale/SaleSetting/saleSettingView'
// import saleCommissionSetting from 'views/CommissionSetting/Sale/SaleSetting/saleCommissionSetting'
// import saleMonthlyResult from 'views/CommissionSetting/Sale/SaleResult/saleMonthlyResult'
// import saleMonCommResult from 'views/CommissionSetting/Sale/SaleResult/saleMonCommResult'
// import saleMonCommDetailResult from 'views/CommissionSetting/Sale/SaleResult/saleMonCommDetailResult'
// import relationshipListReport from 'views/CommissionSetting/Sale/SaleReport/relationshipListReport'
// import mtclientReport from 'views/CommissionSetting/Sale/SaleReport/mtclientReport'
// import saleTemplateMaintenanceV1 from 'views/CommissionSetting/Sale/SaleTemplate/saleTemplateView'

// 利润分成主界面
import profitShareView from 'views/ProfitShareSetting/ProfitShareView';
import accountSetting from 'views/ProfitShareSetting/AccountSetting';
import profitShareReport from 'views/ProfitShareSetting/ProfitShareReport';
import versionReport from 'views/ProfitShareSetting/VersionReport';

// 佣金2.0页面
import commissionView_v2 from 'views/CommissionSetting2/commissionView'
import ibPrimary_v2 from 'views/CommissionSetting2/ibPrimary' // 代理首选项
import salePrimary_v2 from 'views/CommissionSetting2/salePrimary' //销售首选项

// 2.0代理的一些页面
import ibSetting_v2 from 'views/CommissionSetting2/IB/IBSetting/ibSettingView'
import IBCommissionSetting_v2 from 'views/CommissionSetting2/IB/IBSetting/ibCommissionSetting'
import realTimeResult_v2 from 'views/CommissionSetting2/IB/IBResult/realTimeResult'
import realTimeDetailResult_v2 from 'views/CommissionSetting2/IB/IBResult/realTimeDetailResult'
import monthlyIBResult_v2 from 'views/CommissionSetting2/IB/IBResult/monthlyIBResult'
import monthlyIBCommisionResult_v2 from 'views/CommissionSetting2/IB/IBResult/monthlyIBCommisionResult'
import monthCommDetailResult_v2 from 'views/CommissionSetting2/IB/IBResult/monthCommDetailResult'
import CPACommissionResult_v2 from 'views/CommissionSetting2/IB/IBResult/CPACommissionResult'
import CPAMonthlyCommResult_v2 from 'views/CommissionSetting2/IB/IBResult/CPAMonthlyCommResult'
import CPAMonthlyCommDetailResult_v2 from 'views/CommissionSetting2/IB/IBResult/CPAMonthlyCommDetailResult'
import ibReport_v2 from 'views/CommissionSetting2/IB/IBReport/ibReport'
import auditTrailReport_v2 from 'views/CommissionSetting2/IB/IBReport/auditTrailReport'
import auditTrailDetailReport_v2 from 'views/CommissionSetting2/IB/IBReport/auditTrailDetailReport'
import spreadCommissionMappingReport_v2 from 'views/CommissionSetting2/IB/IBReport/spreadCommissionMappingReport'
import allCommissionReport_v2 from 'views/CommissionSetting2/IB/IBReport/allCommissionReport'
import AlertIgnore_v2 from 'views/CommissionSetting2/IB/AlertIgnore/AlertIgnore'
import AlertIgnore_v2_new from 'views/CommissionSetting2/IB/AlertIgnore/AlertIgnore2'
import ibTemplateMaintenance from 'views/CommissionSetting2/IB/IBTemplateSetting/ibTemplateSetting'

// 2.0销售的一些页面
import saleSetting_v2 from 'views/CommissionSetting2/Sale/SaleSetting/saleSettingView'
import saleCommissionSetting_v2 from 'views/CommissionSetting2/Sale/SaleSetting/saleCommissionSetting'
import saleMonthlyResult_v2 from 'views/CommissionSetting2/Sale/SaleResult/saleMonthlyResult'
import saleMonCommResult_v2 from 'views/CommissionSetting2/Sale/SaleResult/saleMonCommResult'
import saleMonCommDetailResult_v2 from 'views/CommissionSetting2/Sale/SaleResult/saleMonCommDetailResult'
import relationshipListReport_v2 from 'views/CommissionSetting2/Sale/SaleReport/relationshipListReport'
import mtclientReport_v2 from 'views/CommissionSetting2/Sale/SaleReport/mtclientReport'
import saleTemplateMaintenance from 'views/CommissionSetting2/Sale/SaleTemplate/saleTemplateView'


// 用于测试功能的页面
Vue.use(Router)

let viewObj = (view, children = []) => new Object({ path: `/${view.name || ""}`, name: (view.name || ""), component: view, children: children }) // 获取router对象方法
let viewItem = (viewObj => view => viewObj(view))(viewObj) // 获取router里的name并调用viewObj方法
let childView = (viewItem => (viewObj = []) => viewObj.map(view => viewItem(view)))(viewItem) // 循环views获取viewObj生产对象的数组
let parentView = (viewObj => (view, children) => viewObj(view, children))(viewObj) // 生成父路由并且把子路由挂上去

let spViewChild = [ // 获取spView子路由
    // viewObj(accountList),
    // viewObj(accountDatum),
    viewObj(authList),
    viewObj(userList),
    viewObj(authOption),
    viewObj(userDatum),
    viewObj(changepswd),
    // viewObj(relation),
    // viewObj(loginSalePlatform),
    // viewObj(changeParentSales),
    // viewObj(changeParentSalesNew),
    // viewObj(clientParentInfo),
    viewObj(dailyReport),
    // 设置 利润分成路由
    viewObj(profitShareView, [
        { path: '/', redirect: '/profit/accountSetting' },
        { path: '/profit/accountSetting', component: accountSetting },
        { path: '/profit/shareReport', component: profitShareReport },
        { path: '/profit/versionReport', component: versionReport }
    ]),

    // 设置 佣金的嵌套路由
    // viewObj(commissionView, [
    //     { path: '/', redirect: '/ibPrimary' },
    //     {
    //         path: '/ibPrimary',
    //         component: ibPrimary,
    //         children: [
    //             { path: '/', redirect: '/ib/ibSetting' },
    //             { path: '/ib/ibSetting', component: ibSetting },
    //             { path: '/ib/realTimeResult', component: realTimeResult },
    //             { path: '/ib/realTimeDetailResult', component: realTimeDetailResult },
    //             { path: '/ib/monthlyIBResult', component: monthlyIBResult },
    //             { path: '/ib/monthlyIBCommisionResult', component: monthlyIBCommisionResult },
    //             { path: '/ib/monthCommDetailResult', component: monthCommDetailResult },
    //             { path: '/ib/CPACommissionResult', component: CPACommissionResult },
    //             { path: '/ib/CPAMonthlyCommResult', component: CPAMonthlyCommResult },
    //             { path: '/ib/CPAMonthlyCommDetailResult', component: CPAMonthlyCommDetailResult },
    //             { path: '/ib/ibReport', component: ibReport },
    //             { path: '/ib/auditTrailReport', component: auditTrailReport },
    //             { path: '/ib/auditTrailDetailReport', component: auditTrailDetailReport },
    //             { path: '/ib/spreadCommissionMappingReport', component: spreadCommissionMappingReport },
    //             { path: '/ib/allCommissionReport', component: allCommissionReport },
    //             { path: '/ib/ibCommissionSetting', component: IBCommissionSetting },
    //             { path: '/ib/alert-ignore-list', component: AlertIgnore },
    //             { path: '/ib/alert-ignore-list2', component: AlertIgnore_new },
    //             { path: '/ib/ibTemplateSetting', component: ibTemplateMaintenanceV1 },
    //         ]
    //     },
    //     {
    //         path: '/salePrimary',
    //         component: salePrimary,
    //         children: [
    //             { path: '/', redirect: '/sale/saleSetting' },
    //             { path: '/sale/saleSetting', component: saleSetting },
    //             { path: '/sale/saleMonthlyResult', component: saleMonthlyResult },
    //             { path: '/sale/saleMonCommResult', component: saleMonCommResult },
    //             { path: '/sale/saleMonCommDetailResult', component: saleMonCommDetailResult },
    //             { path: '/sale/relationshipListReport', component: relationshipListReport },
    //             { path: '/sale/saleCommissionSetting', component: saleCommissionSetting },
    //             { path: '/sale/mtclientReport', component: mtclientReport },
    //             { path: '/sale/saleTemplateSetting', component: saleTemplateMaintenanceV1 },
    //         ]
    //     },
    // ]),
    viewObj(commissionView_v2, [
        { path: '/', redirect: '/ibPrimary_v2' },
        {
            path: '/ibPrimary_v2',
            component: ibPrimary_v2,
            children: [
                { path: '/', redirect: '/ib_v2/ibSetting' },
                { path: '/ib_v2/ibSetting', component: ibSetting_v2 },
                { path: '/ib_v2/realTimeResult', component: realTimeResult_v2 },
                { path: '/ib_v2/realTimeDetailResult', component: realTimeDetailResult_v2 },
                { path: '/ib_v2/monthlyIBResult', component: monthlyIBResult_v2 },
                { path: '/ib_v2/monthlyIBCommisionResult', component: monthlyIBCommisionResult_v2 },
                { path: '/ib_v2/monthCommDetailResult', component: monthCommDetailResult_v2 },
                { path: '/ib_v2/CPACommissionResult', component: CPACommissionResult_v2 },
                { path: '/ib_v2/CPAMonthlyCommResult', component: CPAMonthlyCommResult_v2 },
                { path: '/ib_v2/CPAMonthlyCommDetailResult', component: CPAMonthlyCommDetailResult_v2 },
                { path: '/ib_v2/ibReport', component: ibReport_v2 },
                { path: '/ib_v2/auditTrailReport', component: auditTrailReport_v2 },
                { path: '/ib_v2/auditTrailDetailReport', component: auditTrailDetailReport_v2 },
                { path: '/ib_v2/spreadCommissionMappingReport', component: spreadCommissionMappingReport_v2 },
                { path: '/ib_v2/allCommissionReport', component: allCommissionReport_v2 },
                { path: '/ib_v2/ibCommissionSetting', component: IBCommissionSetting_v2 },
                { path: '/ib_v2/alert-ignore-list', component: AlertIgnore_v2 },
                { path: '/ib_v2/alert-ignore-list2', component: AlertIgnore_v2_new },
                { path: '/ib_v2/ibTemplateSetting', component: ibTemplateMaintenance },
            ]
        },
        {
            path: '/salePrimary_v2',
            component: salePrimary_v2,
            children: [
                { path: '/', redirect: '/sale_v2/saleSetting' },
                { path: '/sale_v2/saleSetting', component: saleSetting_v2 },
                { path: '/sale_v2/saleMonthlyResult', component: saleMonthlyResult_v2 },
                { path: '/sale_v2/saleMonCommResult', component: saleMonCommResult_v2 },
                { path: '/sale_v2/saleMonCommDetailResult', component: saleMonCommDetailResult_v2 },
                { path: '/sale_v2/relationshipListReport', component: relationshipListReport_v2 },
                { path: '/sale_v2/saleCommissionSetting', component: saleCommissionSetting_v2 },
                { path: '/sale_v2/mtclientReport', component: mtclientReport_v2 },
                { path: '/sale_v2/saleTemplateSetting', component: saleTemplateMaintenance },
            ]
        },
    ])
]

let spViewObj = parentView(spView, spViewChild) // 获取spView完整对象
if(window.location.href.indexOf('fromSpbo2')>0) spViewObj = viewObj(commisionIframe,spViewChild)
export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: 'login'
        },
        {
            path: '/fromSpbo2',
            redirect: 'ibPrimary_v2'
        },
        viewObj(login),
        spViewObj
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js